import React, { useState } from "react";
import {
  HtmlEditor,
  Image,
  Inject,
  Link,
  QuickToolbar,
  RichTextEditorComponent,
  Toolbar,
} from "@syncfusion/ej2-react-richtexteditor";
import axios from "axios";
import { Header } from "../components";
import { baseUrl } from "../data/baseURL";
import { useLocation } from "react-router-dom";

const Editor = () => {
  const { state } = useLocation();
  const [title, setTitle] = useState(state?.title ? state.title : "");
  const [landingImage, setLandingImage] = useState(state?.landingImage ? state.landingImage : null);
  const [content, setContent] = useState(state?.content ? state.content : "");
  const [type, setType] = useState(state?.type !== undefined ? state.type : null);
  const [loading, setLoading] = useState(false);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setLandingImage(file); // Store the file directly
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async () => {
    const token = localStorage.getItem("token");
    const publishDate = Math.floor(Date.now() / 1000);
    setLoading(true);

    const formData = new FormData();
    formData.append("Title", title);
    formData.append("Content", content);
    formData.append("PublishDate", publishDate);
    formData.append("Type", type);
    if (landingImage) {
      formData.append("LandingImage", landingImage);
    }

    try {
      const response = await axios.post(`${baseUrl}/Article`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      window.alert("پست با موفقیت ایجاد شد");
      setLoading(false);
    } catch (error) {
      console.error("Error submitting post:", error);
      setLoading(false);
    }
  };

  const handleEdit = async (data) => {
    setLoading(true);
    const token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("Id", state.id);
    formData.append("Title", title);
    formData.append("Content", content);
    formData.append("LandingImage", landingImage);
    formData.append("CategoryId", type);

    try {
      await axios.put(`${baseUrl}/Article`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setLoading(false);
      window.alert("پست با موفقیت ویرایش شد");
    } catch (error) {
      console.error("Error editing post:", error);
      setLoading(false);
    }
  };

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="App" title={state ? "ویرایش پست " + state.id : "ایجاد پست"} />

      <div className="mb-4">
        <input
          type="text"
          className="w-full p-2 border rounded"
          placeholder="عنوان"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>

      <div className="mb-4">
        <input type="file" accept="image/*" onChange={handleImageUpload}/>
      </div>

      <div className="mb-4">
        <RichTextEditorComponent value={content} change={(args) => setContent(args.value)}>
          <Inject services={[HtmlEditor, Toolbar, Image, Link, QuickToolbar]} />
        </RichTextEditorComponent>
      </div>
      <div className="mb-4 flex justify-start items-start gap-4">
        <label className="flex justify-center items-center gap-1">
          <input
            type="radio"
            name="type"
            value={0}
            checked={type == 0}
            onChange={() => setType(0)}
          />
          اخبار
        </label>
        <label className="flex justify-center items-center gap-1">
          <input
            type="radio"
            name="type"
            value={2}
            checked={type == 2}
            onChange={() => setType(2)}
          />
          مرکز محتوا
        </label>
      </div>

      <button
        className="bg-blue-500 text-white p-2 rounded"
        onClick={state ? handleEdit : handleSubmit}
        disabled={loading}
      >
        {loading ? "در حال ارسال..." : (state ? "ویرایش پست" : "ارسال پست")}
      </button>
    </div>
  );
};

export default Editor;
